import React from 'react';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import baseOptions from './options/baseOptions';

const RichText = ({ content, options }) => {
  const richTextOptions = options || baseOptions;
  const coverContent = content?.raw
    ? content
    : {
        raw: content ? JSON.stringify(content) : null,
      };

  return <>{renderRichText(coverContent, richTextOptions)}</>;
};

export default RichText;
